var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThisWeek(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "This week") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "this-week",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1D3066",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 2.75,
    width: 22.5,
    height: 18.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,1.75 C21.6213203,1.75 22.1838203,2.00183983 22.5909903,2.40900974 C22.9981602,2.81617966 23.25,3.37867966 23.25,4 L23.25,4 L23.25,6.25 L0.75,6.25 L0.75,4 C0.75,3.37867966 1.00183983,2.81617966 1.40900974,2.40900974 C1.81617966,2.00183983 2.37867966,1.75 3,1.75 L3,1.75 Z",
    id: "Rectangle",
    stroke: "#1D3066",
    strokeWidth: 1.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1D3066",
    x: 6,
    y: 0,
    width: 1.5,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#1D3066",
    x: 16,
    y: 0,
    width: 1.5,
    height: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#1D3066",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    cx: 5.5,
    cy: 10.5,
    r: 1.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    stroke: "#1D3066",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    cx: 5.5,
    cy: 16.5,
    r: 1.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    stroke: "#1D3066",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    cx: 11.5,
    cy: 10.5,
    r: 1.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-6",
    stroke: "#1D3066",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    cx: 11.5,
    cy: 16.5,
    r: 1.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    stroke: "#1D3066",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    cx: 17.5,
    cy: 10.5,
    r: 1.75
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThisWeek);
export default __webpack_public_path__ + "static/media/this_week.2484eda5ca6034e7b68f58ba8f6a5659.svg";
export { ForwardRef as ReactComponent };